import { FC, ReactNode, useMemo, useState } from 'react';
import { DropdownGroupContext } from './DropdownGroupContext';

export interface IDropdownGroupProps {
  children: ReactNode;
}

/**
 * Groups related dropdown items with accessibility support.
 * Renders a div with role="group" and aria-labelledby pointing to the DropdownGroupLabel.
 */
const DropdownGroup: FC<IDropdownGroupProps> = ({ children }) => {
  const [labelId, setLabelId] = useState<string | undefined>(undefined);

  const context = useMemo(() => ({ setLabelId }), []);

  return (
    <DropdownGroupContext.Provider value={context}>
      <div role="group" aria-labelledby={labelId}>
        {children}
      </div>
    </DropdownGroupContext.Provider>
  );
};

export default DropdownGroup;
